import { useTranslation } from 'react-i18next';

export function PaymentCenterPage() {
  const { t } = useTranslation('members');
  return (
    <section>
      <h2 className="text-base font-semibold">{t('payments.pages.paymentCenter.sectionTitle')}</h2>
      <p className="text-sm text-muted-foreground mt-1">{t('payments.pages.paymentCenter.sectionDescription')}</p>
    </section>
  );
}
